export const RESUME_PARSE_STATUS = {
  PENDING: "pending",
  COMPLETED: "completed",
  FAILED: "failed",
};

export const RESUME_RECORD_STATUS = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  DELETED: "deleted",
};

export const RESUME_STATUS_BADGE_MAP = {
  [RESUME_PARSE_STATUS.PENDING]: {
    label: "Parsing Pending",
    colorScheme: "yellow",
  },
  [RESUME_PARSE_STATUS.COMPLETED]: { label: "Parsed", colorScheme: "green" },
  [RESUME_PARSE_STATUS.FAILED]: { label: "Failed", colorScheme: "red" },
};

export const RESUME_SOURCE_OPTIONS = [
  { label: "Manual Upload", value: "manual_upload" },
  { label: "Candidate Portal", value: "candidate_portal" },
  { label: "Job Portal Sync", value: "job_portal_sync" },
  { label: "Email Ingestion", value: "email_ingestion" },
  { label: "Bulk Upload", value: "bulk_upload" },
  { label: "API Upload", value: "api_upload" },
];
